import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import download from "downloadjs";
import { ApplicationFeature, CompanyType } from "@green0meter/api-client";

import { Button } from "@components/base";
import { useExportAdminCompanies } from "@api";
import { useUserStore } from "@store/user";

interface ExportCompaniesButtonProps {
  search?: string;
}

const ExportCompaniesButton: FC<ExportCompaniesButtonProps> = ({ search }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { exportAdminCompaniesAsync, isPendingExportAdminCompanies } =
    useExportAdminCompanies(user);

  const handleExportCompanies = async (): Promise<void> => {
    const response = await exportAdminCompaniesAsync(search);
    const csvHeader =
      "id,name,companyId,companyType,currencyId,naceDivisionId,ownershipShare,annualTurnover,isExternal,features\n";

    const csvContent =
      csvHeader +
      response
        .map((company) => {
          const features =
            company.companyFeatureFunctionalities
              ?.map((f) => ApplicationFeature[f.applicationFeature as number])
              .join(";") ?? "";

          return [
            company.id,
            `"${company.name?.replace(/"/g, '""') ?? ""}"`,
            company.companyId,
            CompanyType[company.companyType as number],
            company.currencyId ?? "",
            company.naceDivisionId ?? "",
            company.ownershipShare ?? "",
            company.annualTurnover ?? "",
            company.isExternal ?? "",
            `"${features}"`,
          ].join(",");
        })
        .join("\n");

    download(csvContent, `companies_export.csv`, "text/csv");
  };

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleExportCompanies}
      startIcon={<FeatherIcon icon="upload" width="16" height="16" />}
      loading={isPendingExportAdminCompanies}
    >
      {t("common.export")}
    </Button>
  );
};

export default ExportCompaniesButton;
